var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-button',{attrs:{"type":"text"},on:{"click":function($event){_vm.dialogVisible = true}}},[_vm._v("立即投递")]),_c('el-dialog',{attrs:{"title":"上传简历","visible":_vm.dialogVisible,"width":"40%"},on:{"update:visible":function($event){_vm.dialogVisible=$event}}},[_c('span',[_vm._v("功能维护中，请投递邮箱 15309691517@163.com")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }